
import { defineComponent } from "vue";
import buttons from "../components/button.vue";

export default defineComponent({
  name: "shortenForm",
  components: {
    buttons,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
});
